import React, { useState, useEffect } from 'react'
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';

// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';


const OutsourcerCostings = () => {
    const [outsourcerData, setOutsourcerData] = useState([])
    const [jobData, setJobData] = useState([])

    const [outsourcerArray, setOutsourcerArray] = useState([])
    // console.log(outsourcerArray)

    useEffect(() => {
        if (outsourcerArray.length > 0) {
            outsourcerArray.forEach(o => {
                console.log(o.companyName, o.jobs.length)
            })
        }
    }, [outsourcerArray])
    useEffect(() => {
        let arr = [...outsourcerData]
        arr.forEach(a => { a.jobs = [] })
        for (let i = 0; i < jobData.length; i++) {
            if (jobData.length > 0) {
                jobData[i].outsourcers.forEach(job => {
                    if (job.outsourcer) {
                        arr.forEach(a => {
                            if (a.companyName === job.outsourcer) {
                                a.jobs.push(job)
                            }
                        })
                    }
                })
            }
        }
        setOutsourcerArray(arr)
        // eslint-disable-next-line
    }, [jobData, setOutsourcerArray])

    useEffect(() => {
        const q = query(
            collection(db, "JobData"),
            where('year', '==', new Date().getFullYear()),
            orderBy("jobNumber", "desc")
        );

        const unsub = onSnapshot(q, (querySnapshot) => {
            const initialData = querySnapshot.docs.map(d => {
                const data = d.data()
                data.id = d.id
                return data
            })
            setJobData([...initialData])
        })
        return () => {
            unsub()
        }
        // eslint-disable-next-line
    }, [setJobData])

    useEffect(() => {
        const q = query(
            collection(db, "Outsourcers"),
            orderBy("companyName", "asc")
        );

        const unsub = onSnapshot(q, (querySnapshot) => {
            const initialData = querySnapshot.docs.map(outsourcer => {
                const data = outsourcer.data()
                data.id = outsourcer.id
                return data
            })
            setOutsourcerData([...initialData])
        })
        return () => {
            unsub()
        }
        // eslint-disable-next-line
    }, [setOutsourcerData])

    return (
        <div>OutsourcerCostings</div>
    )
}

export default OutsourcerCostings